import { render, staticRenderFns } from "./Sending.vue?vue&type=template&id=3bd909d6&scoped=true"
import script from "./Sending.vue?vue&type=script&lang=js"
export * from "./Sending.vue?vue&type=script&lang=js"
import style0 from "./Sending.vue?vue&type=style&index=0&id=3bd909d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd909d6",
  null
  
)

export default component.exports